export default __webpack_public_path__ + "static/media/picture_jion_02.4e82b93e.png";